/**
 * El eje ya no tiene tres escalas fijas: tiene zoom continuo (`ganttEje.js`).
 *
 * `GANTT_SCALES` era `[dia, semana, mes]` en tres botones. Es la forma mas comun y la peor:
 * cambiar de escala salta y se pierde donde estabas mirando, y ninguna de las tres suele ser la
 * que hace falta —un plan de cinco semanas no entra en "dia" y es una mancha en "mes"—. Quedan
 * como **atajos** a un zoom concreto, no como modos.
 */
export const ATAJOS_DE_ZOOM = [
  { id: 'mes', label: 'Mes', px: 4 },
  { id: 'semana', label: 'Semana', px: 12 },
  { id: 'dia', label: 'Día', px: 26 },
];

export const ROW_TYPE_LABELS = {
  ticket: 'Ticket',
  phase: 'Fase',
  task: 'Tarea',
};
